export default "__VITE_ASSET__CSMmjbAT__"